import { DomainView } from "@/components/domain";
import { Skeleton } from "@/components/ui/skeleton";
import { useSheetContext } from "@/context/sheet";
import { useGetDepartment } from "@/hooks/departments";
import { useDeleteService, useGetService } from "@/hooks/services";
import { T } from "@/i18n";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Key } from "react";

export const Route = createFileRoute("/(services)/services/_sheet/$id/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data, isLoading } = useGetService(id);
  const { data: department, isLoading: departmentLoading } = useGetDepartment(
    data?.departmentId?.toString() ?? "",
    {
      enabled: typeof data?.departmentId === "number",
    },
  );
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutate: deleteService } = useDeleteService({
    onSuccess: () => {
      close(() => {
        navigate({ to: "/services" });
      });
    },
  });

  return (
    <DomainView
      domain="services"
      editLink={(children, key) => (
        <Link to="/services/$id/edit" params={{ id }} key={key as Key}>
          {children}
        </Link>
      )}
      isLoading={isLoading}
      title={data?.name}
      onDelete={() => deleteService(id)}
      propsList={[
        {
          title: "services.fields.type",
          value:
            typeof data?.type === "number" ? (
              <T tKey={`services.types.${data?.type}`} />
            ) : (
              "-"
            ),
        },
        {
          title: "services.fields.description",
          value: data?.description ?? "-",
        },
        {
          title: "services.fields.referencePrice",
          value: data?.referencePrice ?? "-",
        },
        {
          title: "services.fields.paymentModel",
          value:
            typeof data?.paymentModel === "number" ? (
              <T tKey={`services.paymentModels.${data.paymentModel}`} />
            ) : (
              "-"
            ),
        },
        {
          title: "services.fields.departmentId",
          value:
            departmentLoading || !department ? (
              <Skeleton className="h-6 w-full" />
            ) : (
              (department.name ?? "-")
            ),
        },
      ]}
    />
  );
}
